// Types.ts
export const REDUCER_NAME="SuperAdminSlice";
export interface iGenericResponse {
  success: boolean;
  message: string;
  data?: any; // adjust based on API response
}

export interface iStateMessage {
  loading: boolean;
  loadingList:boolean;
  error: string | null;
  message: string | null;

}
export interface iAddProFormInvoiceDetail {
  inspection: string;
  insurance: string;
  freightTransportation: string;
  
 }
export interface iProductReportResponse {
  overviewChart: any[]; // or give a proper type if you know the structure
}
export interface ProFormaInvoce extends iStateMessage {
  productDetail: any | null; 
  loadingDataList:any | null;
  dataList:any | null;
}
